import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { API_URL } from '../../services/api';
import { DataState } from '../../context/DataProvider';

const GithubReposWebhook = () => {
  const [repos, setRepos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggleLoading, setToggleLoading] = useState(null);
  const { userGoogleId: sampleToken } = DataState();

  useEffect(() => {
    const fetchReposStatus = async () => {
      try {
        const res = await fetch(`${API_URL}/github/repos-status`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sampleToken}`,
          },
          credentials: "include"
        });

        const data = await res.json();
        if (data.success) {
          setRepos(data.data);
        } else {
          toast.error(data.message || 'Failed to fetch repositories.');
        }
      } catch (error) {
        toast.error('Error fetching repos: ' + error.message);
      }
      setLoading(false);
    };

    fetchReposStatus();
  }, []);

  const handleToggle = async (repoId) => {
    setToggleLoading(repoId);
    try {
      const res = await fetch(`${API_URL}/github/webhook/toggle`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sampleToken}`,
        },
        credentials: "include",
        body: JSON.stringify({ repo_id: repoId }),
      });

      const data = await res.json();
      if (data.success) {
        setRepos((prevRepos) =>
          prevRepos.map((repo) =>
            repo.repo_id === repoId
              ? { ...repo, webhook_exists: !repo.webhook_exists }
              : repo
          )
        );
        toast.success(`Webhook ${data.webhook_exists ? 'created' : 'deleted'} successfully!`);
      } else {
        toast.error(data.message || 'Failed to toggle webhook.');
      }
    } catch (error) {
      toast.error('Error toggling webhook: ' + error.message);
    }
    setToggleLoading(null);
  };

  return (
    <div className="max-h-96 bg-zinc-900 text-zinc-300 py-8 flex justify-center overflow-y-auto">
      <div className="w-[768px] px-4 ">
        <header className="mb-6">
          <h1 className="text-lg font-bold">GitHub Repositories</h1>
          <p className="mt-1 text-zinc-400">Manage your repository webhooks.</p>
        </header>

        <div className="overflow-x-auto ">
          <table className="w-full bg-zinc-800 rounded-lg">
            <thead className="bg-zinc-800 sticky top-0 z-10">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-zinc-400 w-[300px]">Repository</th>
                <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-zinc-400 w-[150px]">Webhook Status</th>
                <th className="px-4 py-3 text-center text-xs font-medium uppercase tracking-wider text-zinc-400 w-[180px]">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-700">
              {loading
                ? [...Array(5)].map((_, index) => (
                    <tr key={index} className="animate-pulse">
                      <td className="px-4 py-4 w-[300px]">
                        <div className="h-4 bg-zinc-700 rounded w-3/4"></div>
                      </td>
                      <td className="px-4 py-4 w-[150px]">
                        <div className="h-4 bg-zinc-700 rounded w-2/3"></div>
                      </td>
                      <td className="px-4 py-4 text-center w-[180px]">
                        <div className="h-8 bg-zinc-700 rounded w-24 mx-auto"></div>
                      </td>
                    </tr>
                  ))
                : repos.map((repo) => (
                    <tr key={repo.repo_id} className="hover:bg-zinc-700 transition duration-150">
                      <td className="px-4 py-4 w-[300px] text-xs font-medium">{repo.repo_full_name || repo.repo_id}</td>
                      <td className="px-4 py-4 w-[150px] text-xs">{repo.webhook_exists ? 'Enabled' : 'Disabled'}</td>
                      <td className="px-4 py-4 text-center w-[180px]">
                        {repo.is_admin ? (
                          <button
                            onClick={() => handleToggle(repo.repo_id)}
                            disabled={toggleLoading !== null}
                            className={`px-4 py-2 rounded-md text-xs shadow transform transition duration-200 focus:outline-none focus:ring ${
                              repo.webhook_exists ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'
                            } text-white disabled:opacity-50 disabled:cursor-not-allowed`}
                          >
                            {toggleLoading === repo.repo_id ? (
                              <svg className="animate-spin h-5 w-5 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                              </svg>
                            ) : repo.webhook_exists ? (
                              'Delete Webhook'
                            ) : (
                              'Create Webhook'
                            )}
                          </button>
                        ) : (
                          <span className="text-xs text-zinc-500">Insufficient permissions</span>
                        )}
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GithubReposWebhook;
